import React, { useEffect, useRef, useState } from 'react'
import { Space, Button, message } from 'antd'
import get from 'lodash.get'
import merge from 'lodash.merge'
import { useQuery } from 'react-query'
import FormContent from '../FormContent'
import { get3Dlook } from '../../../network/Clients'
import { threeDParsing } from '../../../utils/utils'
import { formOptions } from '../../../forms/blocks'
import {
  BirthdayFormOrder,
  ClientsBodyMeasurementFormExt,
  ClientsBodyMeasurementFormOrder,
  ClientsFootForm,
  OrderComplexionFormP1,
  TDLookForm,
} from '../../../forms/Clients'
import { getFromKey } from '../utils/orderHelpers'

const Step2 = ({
  values,
  errors,
  handleChange,
  handleBack,
  handleNext,
  validateForm,
  saveUserInfos,
  clientDetails,
  saveBeforeSwitch,
  goToPayment,
  canDirectPayment,
}) => {
  const [isValidated, setIsValidated] = useState(false)
  const didMountRef = useRef(false)

  const client3DLDetails = useQuery(
    [
      '3DLooks',
      {
        id: values.customer,
      },
    ],
    () =>
      process.env.NODE_ENV === 'production' ? get3Dlook(values.customer) : {},
    {
      initialData: clientDetails.dlook,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      onSuccess: (res) => {
        if (res?.task_set?.is_ready === false) {
          message.warning('Measure not fully ready yet, refresh again later.')
        }

        const value = {
          measurementSource: '3dlook',
          height: get(values, 'bodyMeasures.height', res?.height),
          weight: get(values, 'bodyMeasures.weight', res?.weight),
          ...threeDParsing(res),
        }

        handleChange({
          target: {
            name: 'bodyMeasures',
            value,
          },
        })
      },
    }
  )

  const formsBody = [
    {
      form: [OrderComplexionFormP1],
      key: 'complexion',
    },
    {
      form: [BirthdayFormOrder],
      key: '',
    },
    {
      form: [
        ClientsBodyMeasurementFormExt,
        TDLookForm,
        ClientsBodyMeasurementFormOrder,
      ],
      key: 'bodyMeasures',
    },
    { form: [ClientsFootForm], key: '' },
  ]

  const handleGoNext = () => {
    saveUserInfos()
    values.orderProducts.forEach((product, index) => {
      if (product.orderProductType === 'custom') {
        // Get suitMeasurementsInfo from client details (only for AF measurement source)
        const measurementSource = get(
          values,
          'bodyMeasures.measurementSource',
          ''
        )

        let suitMeasurementsInfo = {}
        if (measurementSource === 'af') {
          suitMeasurementsInfo = get(
            clientDetails,
            'af.suitMeasurementsInfo',
            {}
          )
        }

        const productType = getFromKey(product)
        let measureDefaultResult

        // Product types that don't have shoulderType parameter
        const productsWithoutShoulderType = [
          'shirt',
          'jean',
          'pant',
          'skirt',
          'shoes',
          'coat',
        ]

        if (productsWithoutShoulderType.includes(productType)) {
          // These product types don't have shoulderType parameter
          measureDefaultResult = formOptions[productType].measureDefault(
            get(values, `bodyMeasures`, {}),
            get(client3DLDetails, 'data', {}),
            get(values, `foot`, {}),
            get(values, 'complexion.fitStyle', 'standard_fit'),
            suitMeasurementsInfo
          )
        } else {
          // Other product types have shoulderType parameter
          measureDefaultResult = formOptions[productType].measureDefault(
            get(values, `bodyMeasures`, {}),
            get(client3DLDetails, 'data', {}),
            get(values, `foot`, {}),
            get(values, 'complexion.fitStyle', 'standard_fit'),
            get(values, 'complexion.shoulderType', 'normal'),
            suitMeasurementsInfo
          )
        }

        handleChange({
          target: {
            name: `orderProducts.${index}.skuMeasurements.0`,
            value: {
              ...measureDefaultResult,
              ...get(values, `orderProducts.${index}.skuMeasurements.0`, {}),
            },
          },
        })
      } else if (product.orderProductType === 'collection') {
        let newDefaultMeasures = {}

        // Get suitMeasurementsInfo for collection products (only for AF measurement source)
        const measurementSource = get(
          values,
          'bodyMeasures.measurementSource',
          ''
        )
        const suitMeasurementsInfo =
          measurementSource === 'af'
            ? get(clientDetails, 'af.suitMeasurementsInfo', {})
            : {}

        product.orderCollection.productType.forEach((e) => {
          // Product types that don't have shoulderType parameter
          const productsWithoutShoulderType = [
            'shirt',
            'jean',
            'pant',
            'skirt',
            'shoes',
            'coat',
          ]

          let measureResult
          if (productsWithoutShoulderType.includes(e)) {
            // These product types don't have shoulderType parameter
            measureResult = formOptions[e].measureDefault(
              get(values, `bodyMeasures`, {}),
              get(client3DLDetails, 'data', {}),
              get(values, `foot`, {}),
              get(values, 'complexion.fitStyle', 'standard_fit'),
              suitMeasurementsInfo
            )
          } else {
            // Other product types have shoulderType parameter
            measureResult = formOptions[e].measureDefault(
              get(values, `bodyMeasures`, {}),
              get(client3DLDetails, 'data', {}),
              get(values, `foot`, {}),
              get(values, 'complexion.fitStyle', 'standard_fit'),
              get(values, 'complexion.shoulderType', 'normal'),
              suitMeasurementsInfo
            )
          }

          newDefaultMeasures = {
            ...measureResult,
            ...newDefaultMeasures,
          }
        })

        newDefaultMeasures = merge(
          newDefaultMeasures,
          get(values, `orderProducts.${index}.skuMeasurements.0`, {})
        )

        handleChange({
          target: {
            name: `orderProducts.${index}.skuMeasurements.0`,
            value: newDefaultMeasures,
          },
        })
      } else if (product.orderProductType === 'fixed_design') {
        let newDefaultMeasures = {}

        // Get suitMeasurementsInfo for fixed_design products (only for AF measurement source)
        const measurementSource = get(
          values,
          'bodyMeasures.measurementSource',
          ''
        )
        const suitMeasurementsInfo =
          measurementSource === 'af'
            ? get(clientDetails, 'af.suitMeasurementsInfo', {})
            : {}

        // Extract product types from details
        const details = get(product, 'orderFixedDesign.details', [])
        const productTypes = []
        
        details.forEach((detail) => {
          Object.keys(detail).forEach((key) => {
            if (key !== '_id' && !productTypes.includes(key)) {
              productTypes.push(key)
            }
          })
        })

        productTypes.forEach((e) => {
          if (formOptions[e] && formOptions[e].measureDefault) {
            // Product types that don't have shoulderType parameter
            const productsWithoutShoulderType = [
              'shirt',
              'jean',
              'pant',
              'skirt',
              'shoes',
              'coat',
            ]

            let measureResult
            if (productsWithoutShoulderType.includes(e)) {
              // These product types don't have shoulderType parameter
              measureResult = formOptions[e].measureDefault(
                get(values, `bodyMeasures`, {}),
                get(client3DLDetails, 'data', {}),
                get(values, `foot`, {}),
                get(values, 'complexion.fitStyle', 'standard_fit'),
                suitMeasurementsInfo
              )
            } else {
              // Other product types have shoulderType parameter
              measureResult = formOptions[e].measureDefault(
                get(values, `bodyMeasures`, {}),
                get(client3DLDetails, 'data', {}),
                get(values, `foot`, {}),
                get(values, 'complexion.fitStyle', 'standard_fit'),
                get(values, 'complexion.shoulderType', 'normal'),
                suitMeasurementsInfo
              )
            }

            newDefaultMeasures = {
              ...measureResult,
              ...newDefaultMeasures,
            }
          }
        })

        newDefaultMeasures = merge(
          newDefaultMeasures,
          get(values, `orderProducts.${index}.skuMeasurements.0`, {})
        )

        handleChange({
          target: {
            name: `orderProducts.${index}.skuMeasurements.0`,
            value: newDefaultMeasures,
          },
        })
      }
    })

    handleNext()
  }

  useEffect(() => {
    if (values?.bodyMeasures?.measurementSource === 'af') {
      handleChange({
        target: {
          name: 'bodyMeasures',
          value: {
            ...get(clientDetails, 'af.bodyMeasurements', {}),
            measurementSource: 'af',
            height: values.bodyMeasures.height,
            weight: values.bodyMeasures.weight,
          },
        },
      })
    } else {
      if (!!client3DLDetails?.data) {
        handleChange({
          target: {
            name: 'bodyMeasures',
            value: {
              measurementSource: '3dlook',
              height: values?.bodyMeasures?.height,
              weight: values?.bodyMeasures?.weight,
              ...threeDParsing(client3DLDetails?.data),
            },
          },
        })
      }
    }
    didMountRef.current = true
  }, [values?.bodyMeasures?.measurementSource])

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <FormContent
        values={values}
        errors={errors}
        hideErrors={!isValidated}
        path=""
        handleChange={handleChange}
        forms={formsBody}
      />
      <Space>
        <Button onClick={handleBack} type="secondary">
          Previous
        </Button>
        <Button
          onClick={() => {
            validateForm().then((res) =>
              Object.keys(res).length ? setIsValidated(true) : handleGoNext()
            )
          }}
          type="primary"
        >
          Next
        </Button>
        {goToPayment && (
          <Button
            disabled={canDirectPayment === false}
            type="primary"
            onClick={() => {
              validateForm().then((res) =>
                Object.keys(res).length ? setIsValidated(true) : goToPayment()
              )
            }}
          >
            Payment
          </Button>
        )}
      </Space>
    </Space>
  )
}

export default Step2
